import { getSdkAuthStore } from '../auth/state/auth-state.js';

const MUTABLE_PUBLIC_PROFILE_FIELDS = [
  'displayName',
  'handle',
  'avatarUrl',
  'avatarPreferences',
  'heroUrl',
  'bio',
  'country',
] as const;

export function applyPublicUserProfileOptimistic<T>(
  previous: T,
  variables: Record<string, unknown>,
  queryKey: readonly unknown[],
): T {
  if (queryKey[0] !== 'users' || queryKey[1] !== 'entity') return previous;
  if (queryKey[2] !== getSdkAuthStore().current().user?.id) return previous;
  if (previous === null || typeof previous !== 'object') return previous;
  let next = previous as Record<string, unknown>;
  for (const field of MUTABLE_PUBLIC_PROFILE_FIELDS) {
    const rawValue = variables[field];
    const value =
      field === 'country' && typeof rawValue === 'string'
        ? rawValue.toUpperCase().trim()
        : rawValue;
    if (value !== undefined && next[field] !== value) {
      next = {
        ...next,
        [field]: value,
        ...(field === 'avatarUrl' ? { avatarNsfw: false } : {}),
      };
    }
  }
  return next as T;
}
